import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import HelpContent from './help-content/HelpContent';

const HelpContainer = ({ activated }) => {
  const popupContainer = document.getElementById('qau-help-container');
  const popupNode = document.createElement('div');

  useEffect(
    activated
      ? () => {
          popupContainer.appendChild(popupNode);
          popupContainer.setAttribute('class', 'active');
          return () => {
            popupContainer.removeChild(popupNode);
            popupContainer.removeAttribute('class');
          };
        }
      : () => {},
    [activated, popupContainer, popupNode],
  );

  return activated ? createPortal(<HelpContent />, popupContainer) : null;
};

const mapStateToProps = ({ help }) => ({
  activated: help.activated,
});

HelpContainer.propTypes = {
  activated: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(HelpContainer);
